var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "200",
      "height": "200",
      "viewBox": "0 0 200 200",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M100 40C70 40 45 65 45 95C45 130 100 170 100 170C100 170 155 130 155 95C155 65 130 40 100 40Z",
      "fill": "#FFC727"
    }
  }), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "95",
      "r": "25",
      "fill": "#FFFFFF"
    }
  }), _c('circle', {
    attrs: {
      "cx": "100",
      "cy": "95",
      "r": "15",
      "fill": "#FFB300"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }